import React, { Component } from 'react';
import { Line} from 'react-konva';

class WaveformPlayTick extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isPlaying: false,
            x: 0
        }
    }

    shouldComponentUpdate(props) {
        if (props.isPlaying !== this.state.isPlaying) {
            this.state.isPlaying = props.isPlaying;

            if (props.isPlaying) {
                this.startTicker();
            } else {
                clearInterval(this.timer);
            }
        }

        return true;
    }

    startTicker() {
        this.timer = setInterval(() => {
            var current = new Date();
            var elapsed = this.props.startOffsetTime * 1000 +
                (current - this.props.startTime);
            var adjusted = (elapsed) % (this.props.duration * 1000);
            this.setState({
                x: this.props.width * adjusted / (this.props.duration * 1000) / 2
            });
        }, 50);
    }

    render() {
        if (!this.props.isPlaying) {
            return (
                <Line></Line>
            );
        }
        return (
            <Line
              x={this.state.x}
              y={0} points={[this.state.x, 0, this.state.x, this.props.height] }
              strokeWidth={1}
              stroke="red"
              fill="red"/>
        );
    }
}

export default WaveformPlayTick;
